export default __webpack_public_path__ + "UI/assets/media/desktop_light-e820f31e.png";